module.exports = __webpack_public_path__ + "img/senado-bt.10cebfc6.jpeg";